import { Link } from 'react-router-dom';

type Props = {
	to: string;
	text: string;
};

export default function InsuranceLicenseAddCta(props: Props) {
	const { to, text } = props;

	return (
		<Link className="insurance-license-add-cta" to={to}>
			<i className="fas fa-fw fa-plus" />
			<span className="insurance-license-add-text">{text}</span>
		</Link>
	);
}
